// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-WitrptpyCsqYqVa2FZF_"};